var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"system-communications-email-header"},[_c('div',{staticClass:"system-communications-email-header-action-wrapper"},[_c('button',{staticClass:"btn btn-primary btn-extra-round",on:{"click":_vm.onClick}},[_vm._v("\n      "+_vm._s(_vm.buttonTitle)+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }